// Даты формы повтора задачи (RecurForm / AddTasks).
// Сравниваем по календарному дню: время у дат из пикера не значимо.

/** Начало дня (локальное время) в мс, либо NaN для пустой/битой даты. */
export function startOfDay(value) {
  if (value === "" || value === null || value === undefined) return NaN;
  const date = new Date(value);
  const time = date.getTime();
  if (isNaN(time)) return NaN;
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

/** Минимальная дата окончания: не раньше сегодня и не раньше начала. */
export function minRecurEndDate(startDate, now = new Date()) {
  const today = startOfDay(now);
  const start = startOfDay(startDate);
  return new Date(isNaN(start) ? today : Math.max(today, start));
}

/** Окончание «в дату» раньше дня начала. Пустые даты — не этот случай. */
export function isRecurEndBeforeStart(startDate, endDate) {
  const start = startOfDay(startDate);
  const end = startOfDay(endDate);
  return !isNaN(start) && !isNaN(end) && end < start;
}
